

angular
.module('inkfinder')
.factory('Operators', function Operators(
  $q,
  $http,
  ENDPOINT,
  Association,
  Session,
  AlertMessages
) {
  // Public Methods
  Operators.update = update;
  Operators.getAllForShop = getAllForShop;
  Operators.get = get;
  Operators.create = create;

  /**
   * @name getOperators
   * @description Get all operators
   * @param {number} shopId The ID of the shop
   * @return {promise} Returns a promise object
   */
  function getAllForShop(shopId) {
    return $q(function(resolve, reject) {
      Association.getShopAssociations(shopId, 'operator', 'operator')
      .then(function(collectors) {
        resolve(collectors.operators);
      }, function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        reject(error);
      });
    });
  }

  /**
   * @name get
   * @description Get an operator
   * @param {unknown} id The Id of the operator to retrieve.
   * @return {promise} Returns a promise object
   */
  function get(id) {
    return $q(function(resolve, reject) {
      let url = ENDPOINT.server + 'operators/api/v1.1/' + id +
      '/?association_id=' + Session.activeState.association.id;
      return $http.get(url)
      .then(function(response) {
        resolve(response.data);
      }, function(error) {
        AlertMessages.add({
          msg: error,
          type: 'danger'
        });
        reject(error);
      });
    });
  }

  /**
   * @name create
   * @description Create an operator
   * @param {object} input The data for the new operator
   * @return {promise} Returns a promist object of the new operator
   */
  function create(input) {
    return $http.post(ENDPOINT.server + 'operators/api/v1.1/', input)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }

  /**
   * @name update
   * @description Update the operator
   * @param {object} operator The updated operator data
   * @return {promise} Returns a promise object of the udpated operator
   */
  function update(operator) {
    operator.association_id = Session.activeState.association.id;
    operator.type = Session.activeState.role;
    return $http.put(ENDPOINT.server + 'operators/api/v1.1/' +
    operator.id + '/', operator)
    .then(function(response) {
      return response.data;
    }, function(error) {
      AlertMessages.add({
        msg: error,
        type: 'danger'
      });
    });
  }
  return Operators;
});



// WEBPACK FOOTER //
// ./components/shop/operators/shop-operators.service.js